import { usePhoneCampaign } from '@hc-frontend/core-ui';
import { Link } from '@hc-frontend/core-ui';

export default function HeaderCallCampaign() {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return (
      <Link
        data-call-call-type={phoneCampaign.callType}
        data-call-placement={phoneCampaign.placement}
        data-call-product={phoneCampaign.product}
        data-call-phone={phoneCampaign.href}
        data-call-advertiser={phoneCampaign.advertiser}
        className="flex py-8-8 px-16-16 items-center gap-8-8 rounded-full border border-solid border-secondary-900 bg-secondary-900/5 shrink-0 text-[#000]"
        href={phoneCampaign.href}
        id="call_now_button"
      >
        <svg
          width="19"
          height="19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m18.081 14.744-4.065-3.696a1 1 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.47-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.39L4.453 1.116a1 1 0 0 0-1.391-.087L.892 2.891a1 1 0 0 0-.29.65c-.015.25-.301 6.171 4.291 10.765 4.006 4.005 9.024 4.298 10.406 4.298.202 0 .326-.006.359-.008a1 1 0 0 0 .648-.29l1.86-2.172a.997.997 0 0 0-.085-1.39Z"
            fill="currentColor"
          />
        </svg>{' '}
        <span className="hidden tablet:block font-bold">
          {phoneCampaign.phoneNumber}{' '}
        </span>
        Call a sales agent
      </Link>
    );
  }
  return null;
}
